import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FormConfig, FormField } from '../shared/form-config-abstract';

@Injectable({
  providedIn: 'root'
})
export class FormsService {

  constructor() { }

  toFormGroup = <T>(config : FormConfig<T>) : UntypedFormGroup => this.toFormGroupByFields(config.fields);

  toFormGroupByFields<T>(fields : Array<FormField<T> | FormField<T>[]>) : UntypedFormGroup {
    const group: {[name : string] : UntypedFormControl} = {};
    
    fields.forEach(field => {
      if(field instanceof Array){
        const subGroup = this.toFormGroupByFields(field);
      }else{
        this._addControl(group, field);
      }
    });
    return new UntypedFormGroup(group);
  }

  _addControl(group : any, field : FormField<any>){
    let val = field.value || (field.options?.length ? field.options[0].key : '');
    let validators = field.validators || [];
    if(field.required){
      validators.push(Validators.required);
    }
    let controlName = field.controlName || (field.name instanceof Array ? field.controlName : field.name);
    group[controlName] = new UntypedFormControl(val , validators);
  }

  toEntity<T>(formValue : any, config : FormConfig<T>) : T{
    let e : T = Object.assign({}, formValue) as T;

    if(formValue['file']){
        delete e['file'];
        Object.assign(e, formValue['file'].fileData());
    }

    if(formValue['dateRange']){
        delete e['dateRange'];
        e['start'] = formValue['dateRange'][0];
        e['end'] = formValue['dateRange'][1];
    }

    this._setCustomControls(e, config, formValue);

    return e;
  }

  _setCustomControls(e : any, config : FormConfig<any> ,values : any){
      config.fields.forEach(f => {
          if(!(f instanceof Array) && f.controlName){
              let control = values[f.controlName];
              this._convertControlData(e, f.controlName, f.name, control);
          }
      });
  }

  _convertControlData = (entity : any, fieldName : string, fields : string[] | string, values : {[key: string] : any}) => {
    delete entity[fieldName];
    let i = 0;
    for(let v in values){
        if(!(values[v] instanceof Function)){
            entity[fields[i++]] = values[v];
        }
    }
  }
}
